<h2>News</h2>
<section class="news-container">
  <div>
    News coming soon,
    stay tuned!
  </div>
</section>
